/* eslint-disable no-fallthrough */
/* eslint-disable import/no-anonymous-default-export */
import {
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_ERROR,
  CLEAR_ERROR,
  FORGET_PASSWORD,
  RESET_PASSWORD_ERROR,
} from "../actions/types";

const initialState = {
  token: localStorage.getItem("token"),
  isAuthenticated: null,
  loading: true,
  user: null,
  error: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_FAIL:
      return {
        ...state,
        error: payload,
      };

    case REGISTER_SUCCESS:
      return {
        ...state,
      };

    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      };

    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false,
      };

    case FORGET_PASSWORD:
      return {
        ...state,
        loading: false,
      };

    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case LOGIN_FAIL:
    case LOGOUT:
    case AUTH_ERROR:
      localStorage.removeItem("token");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
      };

    case USER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case CLEAR_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
      };
    default:
      return state;
  }
}
